// import React, { useState, useEffect } from 'react';
// import {
//   Pane,
//   Heading,
//   Table,
//   SideSheet,
//   Badge,
//   Spinner,
//   toaster,
//   Button,
//   Paragraph,
// } from 'evergreen-ui';
// import { firestore } from '../appservices/firebase';
// import { collection, doc, getDocs, getDoc, query } from 'firebase/firestore';
// import moment from 'moment';

// const TicketView = () => {
//   const [tickets, setTickets] = useState([]);
//   const [filteredTickets, setFilteredTickets] = useState([]);
//   const [summaryFilter, setSummaryFilter] = useState('day'); // 'day', 'week', 'month', 'year'
//   const [isSideSheetOpen, setIsSideSheetOpen] = useState(false);
//   const [selectedTicket, setSelectedTicket] = useState(null);
//   const [loadingTickets, setLoadingTickets] = useState(false);
//   const [sessions, setSessions] = useState([]); // Sessions for the selected ticket
//   const [loadingSessions, setLoadingSessions] = useState(false);

//   useEffect(() => {
//     fetchUserTickets();
//   }, []);

//   useEffect(() => {
//     filterTickets();
//   }, [tickets, summaryFilter]);

//   const fetchUserTickets = async () => {
//     setLoadingTickets(true);
//     try {
//       const userId = 'rCSmdsVJAeVkaTGBws715bfqvDA3'; // Replace with dynamic user ID if available
//       const userRef = doc(firestore, 'users', userId);
//       const userDoc = await getDoc(userRef);

//       if (userDoc.exists()) {
//         const userData = userDoc.data();
//         const ticketIds = Object.keys(userData.tickets || {});

//         if (ticketIds.length > 0) {
//           const ticketPromises = ticketIds.map((ticketId) =>
//             getDoc(doc(firestore, 'tickets', ticketId))
//           );
//           const ticketDocs = await Promise.all(ticketPromises);
//           const ticketsList = ticketDocs
//             .filter((doc) => doc.exists())
//             .map((doc) => ({
//               id: doc.id,
//               ...doc.data(),
//             }));

//           setTickets(ticketsList);
//         } else {
//           console.log("No tickets found for this user.");
//         }
//       } else {
//         console.log("User document not found.");
//       }
//     } catch (error) {
//       console.error('Error fetching user tickets:', error);
//       toaster.danger('Failed to load tickets.');
//     } finally {
//       setLoadingTickets(false);
//     }
//   };

//   const fetchSessions = async (ticketId) => {
//     setLoadingSessions(true);
//     try {
//       const sessionsQuery = query(
//         collection(firestore, `tickets/${ticketId}/sessions`)
//       );
//       const sessionsSnapshot = await getDocs(sessionsQuery);
//       const sessionsList = sessionsSnapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setSessions(sessionsList);
//     } catch (error) {
//       console.error('Error fetching sessions:', error);
//       toaster.danger('Failed to load sessions.');
//     } finally {
//       setLoadingSessions(false);
//     }
//   };

//   const filterTickets = () => {
//     const now = moment();
//     let filtered = [];

//     switch (summaryFilter) {
//       case 'day':
//         filtered = tickets.filter((ticket) =>
//           ticket.created_at && moment(ticket.created_at.toDate()).isSame(now, 'day')
//         );
//         break;
//       case 'week':
//         filtered = tickets.filter((ticket) =>
//           ticket.created_at && moment(ticket.created_at.toDate()).isSame(now, 'week')
//         );
//         break;
//       case 'month':
//         filtered = tickets.filter((ticket) =>
//           ticket.created_at && moment(ticket.created_at.toDate()).isSame(now, 'month')
//         );
//         break;
//       case 'year':
//         filtered = tickets.filter((ticket) =>
//           ticket.created_at && moment(ticket.created_at.toDate()).isSame(now, 'year')
//         );
//         break;
//       default:
//         filtered = tickets;
//     }

//     setFilteredTickets(filtered);
//   };

//   const openTicketDetails = (ticket) => {
//     setSelectedTicket(ticket);
//     setIsSideSheetOpen(true);
//     fetchSessions(ticket.id); // Fetch sessions when a ticket is opened
//   };

//   // Count tickets by status
//   const totalTickets = filteredTickets.length;
//   const openTickets = filteredTickets.filter(ticket => ticket.status === 'Open').length;
//   const closedTickets = filteredTickets.filter(ticket => ticket.status === 'Closed').length;
//   const pendingTickets = filteredTickets.filter(ticket => ticket.status === 'Pending').length;

//   return (
//     <Pane padding={16}>
//       <Heading size={700} marginBottom={16}>Tickets Dashboard</Heading>

//       {/* Ticket Summary */}
//       <Pane marginBottom={32} padding={16} background="tint2" borderRadius={8}>
//         <Heading size={600} marginBottom={16}>Ticket Summary</Heading>

//         {/* Summary Filter with Button Group */}
//         <Pane display="flex" gap={8} marginBottom={16}>
//           {['day', 'week', 'month', 'year'].map((filter) => (
//             <Button
//               key={filter}
//               appearance={summaryFilter === filter ? 'primary' : 'default'}
//               onClick={() => setSummaryFilter(filter)}
//             >
//               {filter.charAt(0).toUpperCase() + filter.slice(1)}
//             </Button>
//           ))}
//         </Pane>

//         {/* Ticket Count Badges */}
//         <Pane display="flex" justifyContent="space-around" marginTop={16}>
//           <Badge color="blue" fontSize={16} paddingX={8} paddingY={4}>
//             Total: {totalTickets}
//           </Badge>
//           <Badge color="green" fontSize={16} paddingX={8} paddingY={4}>
//             Open: {openTickets}
//           </Badge>
//           <Badge color="neutral" fontSize={16} paddingX={8} paddingY={4}>
//             Closed: {closedTickets}
//           </Badge>
//           <Badge color="orange" fontSize={16} paddingX={8} paddingY={4}>
//             Pending: {pendingTickets}
//           </Badge>
//         </Pane>
//       </Pane>

//       {/* Ticket List */}
//       <Pane>
//         <Heading size={600} marginBottom={16}>Tickets</Heading>
//         {loadingTickets ? (
//           <Spinner />
//         ) : filteredTickets.length > 0 ? (
//           <Table>
//             <Table.Head>
//               <Table.TextHeaderCell>Ticket ID</Table.TextHeaderCell>
//               <Table.TextHeaderCell>Subject</Table.TextHeaderCell>
//               <Table.TextHeaderCell>Status</Table.TextHeaderCell>
//               <Table.TextHeaderCell>Created At</Table.TextHeaderCell>
//             </Table.Head>
//             <Table.Body>
//               {filteredTickets.map((ticket) => (
//                 <Table.Row
//                   key={ticket.id}
//                   isSelectable
//                   onSelect={() => openTicketDetails(ticket)}
//                 >
//                   <Table.TextCell>{ticket.id}</Table.TextCell>
//                   <Table.TextCell>{ticket.subject}</Table.TextCell>
//                   <Table.TextCell>
//                     <Badge
//                       color={
//                         ticket.status === 'Open'
//                           ? 'green'
//                           : ticket.status === 'Pending'
//                           ? 'orange'
//                           : 'neutral'
//                       }
//                     >
//                       {ticket.status}
//                     </Badge>
//                   </Table.TextCell>
//                   <Table.TextCell>
//                     {ticket.created_at && ticket.created_at.toDate 
//                         ? moment(ticket.created_at.toDate()).format('YYYY-MM-DD HH:mm')
//                         : 'Date not available'}
//                   </Table.TextCell>
//                 </Table.Row>
//               ))}
//             </Table.Body>
//           </Table>
//         ) : (
//           <Pane padding={16} background="tint1" borderRadius={4}>
//             <Paragraph>No tickets available for this time period.</Paragraph>
//           </Pane>
//         )}
//       </Pane>

//       {/* SideSheet for Ticket Details */}
//       <SideSheet
//         isShown={isSideSheetOpen}
//         onCloseComplete={() => {
//           setIsSideSheetOpen(false);
//           setSelectedTicket(null);
//           setSessions([]); // Clear sessions when closing
//         }}
//         title="Ticket Details"
//       >
//         {selectedTicket && (
//           <Pane padding={16}>
//             <Heading size={600} marginBottom={16}>
//               {selectedTicket.subject}
//             </Heading>
//             <Pane marginBottom={16}>
//               <Badge
//                 color={
//                   selectedTicket.status === 'Open'
//                     ? 'green'
//                     : selectedTicket.status === 'Pending'
//                     ? 'orange'
//                     : 'neutral'
//                 }
//               >
//                 {selectedTicket.status}
//               </Badge>
//             </Pane>
//             <Pane>
//               <Heading size={400} marginBottom={8}>Description</Heading>
//               <Paragraph>{selectedTicket.description}</Paragraph>
//             </Pane>
//             <Pane marginTop={16}>
//               <Heading size={400} marginBottom={8}>Created At</Heading>
//               <Paragraph>
//                 {selectedTicket.created_at && selectedTicket.created_at.toDate 
//                     ? moment(selectedTicket.created_at.toDate()).format('YYYY-MM-DD HH:mm')
//                     : 'Date not available'}
//               </Paragraph>
//             </Pane>

//             {/* Sessions */}
//             <Pane marginTop={16}>
//               <Heading size={500} marginBottom={8}>Sessions</Heading>
//               {loadingSessions ? (
//                 <Spinner />
//               ) : sessions.length > 0 ? (
//                 sessions.map((session) => (
//                   <Pane key={session.id} padding={8} borderBottom="1px solid #e4e7eb">
//                     <Heading size={400}>{session.type}</Heading>
//                     <Paragraph>{session.message}</Paragraph>
//                     <Paragraph>
//                       <strong>Author:</strong> {session.author}
//                     </Paragraph>
//                     <Paragraph>
//                       <strong>Created At:</strong>{' '}
//                       {session.created_at && session.created_at.toDate 
//                           ? moment(session.created_at.toDate()).format('YYYY-MM-DD HH:mm')
//                           : 'Date not available'}
//                     </Paragraph>
//                   </Pane>
//                 ))
//               ) : (
//                 <Paragraph>No sessions available for this ticket.</Paragraph>
//               )}
//             </Pane>
//           </Pane>
//         )}
//       </SideSheet>
//     </Pane>
//   );
// };

// export default TicketView;



import React, { useState, useEffect } from 'react';
import {
  Pane,
  Heading,
  Table,
  SideSheet,
  Badge,
  Spinner,
  toaster,
  Button,
  Paragraph,
} from 'evergreen-ui';
import { firestore } from '../appservices/firebase';
import { collection, doc, getDocs, getDoc, query } from 'firebase/firestore';
import moment from 'moment';

const TicketView = () => {
  const [tickets, setTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [summaryFilter, setSummaryFilter] = useState('day'); // 'day', 'week', 'month', 'year'
  const [isSideSheetOpen, setIsSideSheetOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [loadingTickets, setLoadingTickets] = useState(false);
  const [sessions, setSessions] = useState([]); // Sessions for the selected ticket
  const [loadingSessions, setLoadingSessions] = useState(false);

  useEffect(() => {
    fetchUserTickets();
  }, []);

  useEffect(() => {
    filterTickets();
  }, [tickets, summaryFilter]);

  const fetchUserTickets = async () => {
    setLoadingTickets(true);
    try {
      const userId = 'rCSmdsVJAeVkaTGBws715bfqvDA3'; // Replace with dynamic user ID if available
      const userRef = doc(firestore, 'Users', userId);
      const userDoc = await getDoc(userRef);

      if (userDoc.exists()) {
        const userData = userDoc.data();
        const ticketIds = Object.keys(userData.tickets || {});

        if (ticketIds.length > 0) {
          const ticketPromises = ticketIds.map((ticketId) =>
            getDoc(doc(firestore, 'tickets', ticketId))
          );
          const ticketDocs = await Promise.all(ticketPromises);
          const ticketsList = ticketDocs
            .filter((doc) => doc.exists())
            .map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));

          setTickets(ticketsList);
        } else {
          console.log("No tickets found for this user.");
        }
      } else {
        console.log("User document not found.");
      }
    } catch (error) {
      console.error('Error fetching user tickets:', error);
      toaster.danger('Failed to load tickets.');
    } finally {
      setLoadingTickets(false);
    }
  };

  const fetchSessions = async (ticketId) => {
    setLoadingSessions(true);
    try {
      const sessionsQuery = query(
        collection(firestore, `tickets/${ticketId}/sessions`)
      );
      const sessionsSnapshot = await getDocs(sessionsQuery);
      const sessionsList = sessionsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSessions(sessionsList);
    } catch (error) {
      console.error('Error fetching sessions:', error);
      toaster.danger('Failed to load sessions.');
    } finally {
      setLoadingSessions(false);
    }
  };

  const filterTickets = () => {
    const now = moment();
    let filtered = [];

    switch (summaryFilter) {
      case 'day':
        filtered = tickets.filter((ticket) =>
          ticket.createdAt && moment(ticket.createdAt.toDate()).isSame(now, 'day')
        );
        break;
      case 'week':
        filtered = tickets.filter((ticket) =>
          ticket.createdAt && moment(ticket.createdAt.toDate()).isSame(now, 'week')
        );
        break;
      case 'month':
        filtered = tickets.filter((ticket) =>
          ticket.createdAt && moment(ticket.createdAt.toDate()).isSame(now, 'month')
        );
        break;
      case 'year':
        filtered = tickets.filter((ticket) =>
          ticket.createdAt && moment(ticket.createdAt.toDate()).isSame(now, 'year')
        );
        break;
      default:
        filtered = tickets;
    }

    setFilteredTickets(filtered);
  };

  const openTicketDetails = (ticket) => {
    setSelectedTicket(ticket);
    setIsSideSheetOpen(true);
    fetchSessions(ticket.id); // Fetch sessions when a ticket is opened
  };

  // Count tickets by status
  const totalTickets = filteredTickets.length;
  const openTickets = filteredTickets.filter(ticket => ticket.status === 'Open').length;
  const closedTickets = filteredTickets.filter(ticket => ticket.status === 'Closed').length;
  const pendingTickets = filteredTickets.filter(ticket => ticket.status === 'Pending').length;

  return (
    <Pane padding={16}>
      <Heading size={700} marginBottom={16}>Tickets Dashboard</Heading>

      {/* Ticket Summary */}
      <Pane marginBottom={32} padding={16} background="tint2" borderRadius={8}>
        <Heading size={600} marginBottom={16}>Ticket Summary</Heading>

        {/* Summary Filter with Button Group */}
        <Pane display="flex" gap={8} marginBottom={16}>
          {['day', 'week', 'month', 'year'].map((filter) => (
            <Button
              key={filter}
              appearance={summaryFilter === filter ? 'primary' : 'default'}
              onClick={() => setSummaryFilter(filter)}
            >
              {filter.charAt(0).toUpperCase() + filter.slice(1)}
            </Button>
          ))}
        </Pane>

        {/* Ticket Count Badges */}
        <Pane display="flex" justifyContent="space-around" marginTop={16}>
          <Badge color="blue" fontSize={16} paddingX={8} paddingY={4}>
            Total: {totalTickets}
          </Badge>
          <Badge color="green" fontSize={16} paddingX={8} paddingY={4}>
            Open: {openTickets}
          </Badge>
          <Badge color="neutral" fontSize={16} paddingX={8} paddingY={4}>
            Closed: {closedTickets}
          </Badge>
          <Badge color="orange" fontSize={16} paddingX={8} paddingY={4}>
            Pending: {pendingTickets}
          </Badge>
        </Pane>
      </Pane>

      {/* Ticket List */}
      <Pane>
        <Heading size={600} marginBottom={16}>Tickets</Heading>
        {loadingTickets ? (
          <Spinner />
        ) : filteredTickets.length > 0 ? (
          <Table>
            <Table.Head>
              <Table.TextHeaderCell>Ticket ID</Table.TextHeaderCell>
              <Table.TextHeaderCell>Subject</Table.TextHeaderCell>
              <Table.TextHeaderCell>Status</Table.TextHeaderCell>
              <Table.TextHeaderCell>Priority</Table.TextHeaderCell>
              <Table.TextHeaderCell>Created At</Table.TextHeaderCell>
            </Table.Head>
            <Table.Body>
              {filteredTickets.map((ticket) => (
                <Table.Row
                  key={ticket.id}
                  isSelectable
                  onSelect={() => openTicketDetails(ticket)}
                >
                  <Table.TextCell>{ticket.id}</Table.TextCell>
                  <Table.TextCell>{ticket.title}</Table.TextCell>
                  <Table.TextCell>
                    <Badge
                      color={
                        ticket.status === 'Open'
                          ? 'green'
                          : ticket.status === 'Pending'
                          ? 'orange'
                          : 'neutral'
                      }
                    >
                      {ticket.status}
                    </Badge>
                  </Table.TextCell>
                  <Table.TextCell>
                    <Badge
                      color={
                        ticket.priority === 'High' || ticket.priority === 'Urgent'
                          ? 'red'
                          : ticket.priority === 'Medium'
                          ? 'yellow'
                          : 'green'
                      }
                    >
                      {ticket.priority}
                    </Badge>
                  </Table.TextCell>
                  <Table.TextCell>
                    {ticket.createdAt && ticket.createdAt.toDate 
                        ? moment(ticket.createdAt.toDate()).format('YYYY-MM-DD HH:mm')
                        : 'Date not available'}
                  </Table.TextCell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        ) : (
          <Pane padding={16} background="tint1" borderRadius={4}>
            <Paragraph>No tickets available for this time period.</Paragraph>
          </Pane>
        )}
      </Pane>

      {/* SideSheet for Ticket Details */}
      <SideSheet
        isShown={isSideSheetOpen}
        onCloseComplete={() => {
          setIsSideSheetOpen(false);
          setSelectedTicket(null);
          setSessions([]); // Clear sessions when closing
        }}
        title="Ticket Details"
        width={800}
      >
        {selectedTicket && (
          <Pane padding={16}>
            <Heading size={600} marginBottom={16}>
              {selectedTicket.title}
            </Heading>
            <Pane marginBottom={16} display="flex" alignItems="center" gap={8}>
              <Badge
                color={
                  selectedTicket.status === 'Open'
                    ? 'green'
                    : selectedTicket.status === 'Pending'
                    ? 'orange'
                    : 'neutral'
                }
              >
                {selectedTicket.status}
              </Badge>
              <Badge
                color={
                  selectedTicket.priority === 'High' || selectedTicket.priority === 'Urgent'
                    ? 'red'
                    : selectedTicket.priority === 'Medium'
                    ? 'yellow'
                    : 'green'
                }
              >
                {selectedTicket.priority}
              </Badge>
            </Pane>

            {/* Customer and Product Details */}
            <Pane display="flex" gap={16} marginBottom={16}>
              {/* Customer Details */}
              <Pane flex="1">
                <Heading size={500} marginBottom={8}>Customer Details</Heading>
                <Paragraph><strong>Name:</strong> {`${selectedTicket.customer?.firstName} ${selectedTicket.customer?.lastName}`}</Paragraph>
                <Paragraph><strong>Email:</strong> {selectedTicket.customer?.email}</Paragraph>
                <Paragraph><strong>Phone:</strong> {selectedTicket.customer?.phone}</Paragraph>
                <Paragraph><strong>Address:</strong> {selectedTicket.customer?.address || 'N/A'}</Paragraph>
              </Pane>

              {/* Product Details */}
              <Pane flex="1">
                <Heading size={500} marginBottom={8}>Product Details</Heading>
                <Paragraph><strong>Name:</strong> {selectedTicket.product?.name}</Paragraph>
                <Paragraph><strong>Model:</strong> {selectedTicket.product?.model}</Paragraph>
                <Paragraph><strong>Serial Number:</strong> {selectedTicket.product?.serialNumber}</Paragraph>
                <Paragraph><strong>Purchase Date:</strong> {selectedTicket.product?.purchaseDate ? moment(selectedTicket.product.purchaseDate.toDate()).format('YYYY-MM-DD') : 'N/A'}</Paragraph>
                <Paragraph><strong>Warranty Status:</strong> {selectedTicket.product?.warrantyStatus}</Paragraph>
              </Pane>
            </Pane>

            {/* Support Eligibility */}
            <Pane marginBottom={16}>
              <Heading size={500} marginBottom={8}>Support Eligibility</Heading>
              <Paragraph><strong>Support Tier:</strong> {selectedTicket.supportTier}</Paragraph>
              <Paragraph><strong>Subscription Status:</strong> {selectedTicket.subscriptionStatus}</Paragraph>
            </Pane>

            {/* Assigned To */}
            <Pane marginBottom={16}>
              <Heading size={500} marginBottom={8}>Assigned To</Heading>
              {selectedTicket.assignedTo && selectedTicket.assignedTo.length > 0 ? (
                selectedTicket.assignedTo.map((agentRef) => (
                  <AssignedAgent key={agentRef} agentRef={agentRef} />
                ))
              ) : (
                <Paragraph>No agents assigned.</Paragraph>
              )}
            </Pane>

            {/* Ticket Description */}
            <Pane marginBottom={16}>
              <Heading size={500} marginBottom={8}>Description</Heading>
              <Paragraph>{selectedTicket.description}</Paragraph>
            </Pane>

            {/* Interaction History */}
            <Pane marginBottom={16}>
              <Heading size={500} marginBottom={8}>Interaction History</Heading>
              {selectedTicket.interactionHistory && selectedTicket.interactionHistory.length > 0 ? (
                selectedTicket.interactionHistory.map((interaction, index) => (
                  <Pane key={index} padding={8} borderBottom="1px solid #e4e7eb">
                    <Paragraph><strong>Date:</strong> {interaction.date ? moment(interaction.date.toDate()).format('YYYY-MM-DD HH:mm') : 'N/A'}</Paragraph>
                    <Paragraph><strong>Issue:</strong> {interaction.issue}</Paragraph>
                    <Paragraph><strong>Resolution:</strong> {interaction.resolution}</Paragraph>
                  </Pane>
                ))
              ) : (
                <Paragraph>No interaction history.</Paragraph>
              )}
            </Pane>

            {/* Sessions */}
            <Pane marginBottom={16}>
              <Heading size={500} marginBottom={8}>Sessions</Heading>
              {loadingSessions ? (
                <Spinner />
              ) : sessions.length > 0 ? (
                sessions.map((session) => (
                  <Pane key={session.id} padding={8} borderBottom="1px solid #e4e7eb">
                    <Heading size={400}>{session.type}</Heading>
                    <Paragraph>{session.message}</Paragraph>
                    <Paragraph>
                      <strong>Author:</strong> {session.author}
                    </Paragraph>
                    <Paragraph>
                      <strong>Created At:</strong>{' '}
                      {session.createdAt && session.createdAt.toDate 
                          ? moment(session.createdAt.toDate()).format('YYYY-MM-DD HH:mm')
                          : 'Date not available'}
                    </Paragraph>
                  </Pane>
                ))
              ) : (
                <Paragraph>No sessions available for this ticket.</Paragraph>
              )}
            </Pane>
          </Pane>
        )}
      </SideSheet>
    </Pane>
  );
};

// Helper component to display assigned agent details
const AssignedAgent = ({ agentRef }) => {
  const [agent, setAgent] = useState(null);

  useEffect(() => {
    const fetchAgent = async () => {
      try {
        const agentDoc = await getDoc(doc(firestore, agentRef));
        if (agentDoc.exists()) {
          setAgent(agentDoc.data());
        }
      } catch (error) {
        console.error('Error fetching agent:', error);
      }
    };

    fetchAgent();
  }, [agentRef]);

  return agent ? (
    <Paragraph>{`${agent.firstName} ${agent.lastName} (${agent.role})`}</Paragraph>
  ) : (
    <Spinner size={16} />
  );
};

export default TicketView;
